import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Anchor, Container, Divider, SimpleGrid, Stack, Text } from '@mantine/core';
import { CONTACT_EMAIL, CONTACT_PHONE, CONTACT_PHONE_HREF } from '@/lib/contacts';
import { ROUTES } from '@/routes/paths';

const linkStyle = { color: 'var(--mantine-color-text)' } as const;

// Единый подвал сайта: до входа и в кабинете состав и разметка одинаковые (решение пользователя 2026-11-02).
export default function AppFooter() {
  const { t } = useTranslation();

  return (
    <Container component="footer" size="lg" py="xl" w="100%">
      <Divider mb="lg" />
      <SimpleGrid cols={{ base: 1, xs: 2, sm: 3, lg: 5 }} spacing="lg">
        <Stack gap="xs">
          <Anchor component={Link} to={ROUTES.ABOUT} style={linkStyle} size="sm" underline="hover">
            {t('nav.about')}
          </Anchor>
        </Stack>

        <Stack gap="xs">
          <Anchor component={Link} to={ROUTES.TERMS} style={linkStyle} size="sm" underline="hover">
            {t('static.terms.title')}
          </Anchor>
          <Anchor component={Link} to={ROUTES.SUPPLY} style={linkStyle} size="sm" underline="hover">
            {t('static.supply.title')}
          </Anchor>
          <Anchor component={Link} to={ROUTES.TEO} style={linkStyle} size="sm" underline="hover">
            {t('static.teo.title')}
          </Anchor>
        </Stack>

        <Stack gap="xs">
          <Anchor component={Link} to={ROUTES.POLICY} style={linkStyle} size="sm" underline="hover">
            {t('footer.policy')}
          </Anchor>
          <Anchor href="/docs/diadoc-setup.pdf" target="_blank" rel="noopener noreferrer" style={linkStyle} size="sm" underline="hover">
            {t('footer.diadoc')}
          </Anchor>
        </Stack>

        <Stack gap="xs">
          <Anchor href="/docs/seller-guide.pdf" target="_blank" rel="noopener noreferrer" style={linkStyle} size="sm" underline="hover">
            {t('footer.sellerGuide')}
          </Anchor>
          <Anchor href="/docs/buyer-guide.pdf" target="_blank" rel="noopener noreferrer" style={linkStyle} size="sm" underline="hover">
            {t('footer.buyerGuide')}
          </Anchor>
        </Stack>

        <Stack gap="xs">
          <Anchor href={`mailto:${CONTACT_EMAIL}`} c="brand.7" fw={500} size="sm">
            {CONTACT_EMAIL}
          </Anchor>
          <Anchor href={CONTACT_PHONE_HREF} c="brand.7" fw={500} size="sm">
            {CONTACT_PHONE}
          </Anchor>
        </Stack>
      </SimpleGrid>

      <Text c="gray.7" size="xs" mt="xl">
        {t('footer.cookie')}
      </Text>
    </Container>
  );
}
